module.exports = __webpack_public_path__ + "static/media/should-we-learn-reactjs.b43efa2b.png";